"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uuid_1 = require("uuid");
const applySwitchToLatestContentCommand_1 = require("../../applyCommand/applySwitchToLatestContentCommand");
const getContentType_1 = require("../../helpers/getContentType");
const command_1 = require("../../type/command");
const entity_1 = require("../../type/entity");
function getContentSwitchCommand(command) {
    try {
        const { creatorId, versions = [], userId, timeStamp, rootContentId, libraryVersion } = command;
        return {
            creatorId,
            id: uuid_1.v4(),
            libraryVersion,
            rootContentId,
            timeStamp,
            type: command_1.CommandType.SWITCH_TO_LATEST_CONTENT,
            userId,
            versions
        };
    }
    catch (error) {
        throw error;
    }
}
function switchAllChildContents(command, childContents, user, states, enrolments) {
    try {
        let updatedStates = states;
        let updatedEnrolments = enrolments;
        const events = [];
        childContents.forEach(childContent => {
            const switchContentCommand = getContentSwitchCommand(command);
            const switchContentPayload = applySwitchToLatestContentCommand_1.applySwitchToLatestContentCommand(switchContentCommand, user, childContent, [], updatedStates, updatedEnrolments);
            updatedStates = switchContentPayload.states;
            updatedEnrolments = switchContentPayload.enrolments;
            events.push(...switchContentPayload.events);
        });
        return {
            states: updatedStates,
            enrolments: updatedEnrolments,
            events
        };
    }
    catch (error) {
        throw new Error('Error in switchAllChildContents ' + error);
    }
}
function switchToLatestContent(command, content, childContents, user, states, enrolments) {
    try {
        let updatedStates = states;
        let updatedEnrolments = enrolments;
        const events = [];
        const switchCommand = getContentSwitchCommand(command);
        const switchContentPayload = applySwitchToLatestContentCommand_1.applySwitchToLatestContentCommand(switchCommand, user, content, childContents, updatedStates, updatedEnrolments);
        updatedStates = switchContentPayload.states;
        updatedEnrolments = switchContentPayload.enrolments;
        events.push(...switchContentPayload.events);
        const contentType = getContentType_1.getContentType(content);
        if (contentType === entity_1.ContentType.CURRICULUM) {
            const swtichAllChildContentPayload = switchAllChildContents(command, childContents, user, updatedStates, updatedEnrolments);
            events.push(...swtichAllChildContentPayload.events);
            updatedStates = swtichAllChildContentPayload.states;
            updatedEnrolments = swtichAllChildContentPayload.enrolments;
            events.push(...swtichAllChildContentPayload.events);
        }
        return {
            states: updatedStates,
            enrolments: updatedEnrolments,
            events
        };
    }
    catch (error) {
        throw new Error('Error in switchToLatestContent ' + error);
    }
}
exports.switchToLatestContent = switchToLatestContent;
//# sourceMappingURL=switchToLatestContent.js.map